<template>
    <div class="memberManage">
        <el-col :span="24" style="padding-bottom: 0px">
            <el-form :inline="true" :model="form" label-width="auto">
                <el-form-item label="日期">
                    <div class="block">
                        <el-date-picker v-model="form.date" type="daterange" range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期" @change="onPick" format="yyyy-MM-dd ">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="搜索">
                    <el-input v-model="form.searchKey" placeholder="请输入要查询的代理名称或账号" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search()"></el-button>
                </el-form-item>
                <!-- <el-button type="primary" size="medium" @click="addGoods=true">
          <i class="el-icon-circle-plus"></i>&nbsp;
          导出
        </el-button> -->
            </el-form>
        </el-col>
        <el-col :span="24" style="margin-top:20px">
            <el-table :data="tableData" border style="width:100%">
                <el-table-column label="订单号" prop="order_sn" align="center"></el-table-column>
                <el-table-column label="代理账号" prop="agent_account" align="center"></el-table-column>
                <el-table-column label="代理名称" prop="agentname" align="center"></el-table-column>
                <el-table-column label="网吧名称" prop="name" align="center"></el-table-column>
                <!--<el-table-column label="ip" prop="ip" align="center"></el-table-column>-->
                <el-table-column label="终端包月单价（元）" prop="uprice" align="center"></el-table-column>
                <el-table-column label="终端数量" prop="count" align="center"></el-table-column>
                <el-table-column label="订单时长（月）" prop="month" align="center"></el-table-column>
                <el-table-column label="金额（元）" prop="amount" align="center"></el-table-column>
                <el-table-column label="充值时间" prop="pay_at" align="center"></el-table-column>
                <el-table-column label="到期时间" prop="end_at" align="center"></el-table-column>
            </el-table>
        </el-col>
        <!--分页条-->
        <div style="margin-top: 15px;display: inline-block"><span>订单总金额：</span><span>{{samount+' 元'}}</span></div>
        <el-pagination :total=total :page-size="1" :current-page=currentPage @current-change="handleCurrentChange"
                       :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!--启用按钮-->
        <el-dialog title="提示" :visible.sync="useVisible" width="30%" center>
            <div class="tooltips">{{this.form.start}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="useVisible = false">取 消</el-button>
                <el-button type="primary" @click="stopRow()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
  import * as sysApi from '../../common/sys'
  import { formatDate } from '../../common/utils'

  export default {
    data () {
      return {
        form: {
          status: '全部',
          searchKey: '',
          date: formatDate(new Date(), 'yyyy-MM-dd'),
          starttime: '',
          endtime: '',
          start: ''
        },
        currentPage: 1,
        useVisible: false,
        tableData: [],
        samount: 0,
        total: 1,
        status: [
          {
            statusId: 1,
            label: '全部'
          },
          {
            statusId: 2,
            label: '正常'
          },
          {
            statusId: 3,
            label: '禁用'
          }
        ],

        rowId: ''
      }
    },
    methods: {

      onPick (val) {
        this.currentPage = 1
        if (val == null) {
          var start_time = ''
          var end_time = ''
        } else {

          var start_time = formatDate(val[0], 'yyyy-MM-dd')
          var end_time = formatDate(val[1], 'yyyy-MM-dd')
        }
        this.form.starttime = start_time
        this.form.endtime = end_time
        var pa = {
          'type': 'agent',       //列表类型，cyber为网吧 agent为代理商,默认为agent
          'start_at': this.form.starttime,  //开始时间
          'end_at': this.form.endtime,     //结束时间
          'search_name': this.form.searchKey,
          'page': this.currentPage //搜索名称
        }
        sysApi.month_order(JSON.stringify(pa))
          .then(res => {
            this.tableData = res.data
            this.total = res.count
            this.samount=res.samount
            console.log(res)
          })
          .catch(err => console.log('请求异常信息:' + err))
      },
      search () {
        this.currentPage = 1
        var pa = {
          'type': 'agent',       //列表类型，cyber为网吧 agent为代理商,默认为agent
          'start_at': this.form.starttime,  //开始时间
          'end_at': this.form.endtime,     //结束时间
          'search_name': this.form.searchKey,
          'page': this.currentPage //搜索名称
        }
        sysApi.month_order(JSON.stringify(pa))
          .then(res => {
            this.tableData = res.data
            this.samount=res.samount
            this.total = res.count
            console.log(res)
          })
          .catch(err => console.log('请求异常信息:' + err))
      },

      handleCurrentChange (val) {
        this.currentPage = parseInt(`${val}`)
        var pa = {
          'type': 'agent',       //列表类型，cyber为网吧 agent为代理商,默认为agent
          'start_at': this.form.starttime,  //开始时间
          'end_at': this.form.endtime,     //结束时间
          'search_name': this.form.searchKey,
          'page': this.currentPage //搜索名称
        }
        sysApi.month_order(JSON.stringify(pa))
          .then(res => {
            this.tableData = res.data
            this.samount=res.samount
            this.total = res.count
            console.log(res)
          })
          .catch(err => console.log('请求异常信息:' + err))
      }
    },

    created () {
      var pa = {
        'type': 'agent',       //列表类型，cyber为网吧 agent为代理商,默认为agent
        'start_at': this.form.starttime,  //开始时间
        'end_at': this.form.endtime,     //结束时间
        'search_name': this.form.searchKey,
        'page': this.currentPage //搜索名称
      }
      sysApi.month_order(JSON.stringify(pa))
        .then(res => {
          this.tableData = res.data
          this.samount=res.samount
          this.total = res.count
          console.log(res)
        })
        .catch(err => console.log('请求异常信息:' + err))

    }
  }
</script>
<style>

</style>
